<template>
  <div class="block">
    <div class="block-wrap">
      <h2 class="h2">信息公开</h2>
      <div class="tab" :class="{ 'mobile-layout': platform === 'mobile' }">
        <div :class="['tab-item', { active: activeIndex == item.id }]" v-for="(item, index) in tabList" :key="index" @click="toggle(item.id)">
          {{ item.title }}
        </div>
      </div>
      <div class="list" :class="{ 'mobile-layout': platform === 'mobile' }">
        <div class="list-item" v-for="(item, index) in list" :key="index" @click="handleToNewsDetails(item)">
          <div class="picture-box">
            <img :src="item.cover" class="pictrue"/>
            <!-- <div class="mask">
              <a class="btn">查看详情</a>
              <a class="btn">下载</a>
            </div> -->
          </div>
          <h3 class="title">{{ item.title }}</h3>
        </div>
      </div>
      <div class="btn-more" :class="{ 'mobile-layout': platform === 'mobile' }">
       <el-button class="morebtn" @click="lookMore">查看更多</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["platform"]),
  },
  data() {
    return {
      activeIndex: 1,
      tabList: [],
      list: [],
    };
  },
  mounted() {
    this.getType();
  },
  methods: {
    async getType() {
      const res = await CifuAPI.getReportType();
      if (res.code == 1) {
        this.activeIndex = res.data[0].id;
        this.tabList = res.data;
        this.getList();
      }
    },
    async getList() {
      const res = await CifuAPI.getReportList({ type_id: this.activeIndex, limit: 4 });
      if (res.code == 1) {
        this.list = res.data;
      }
    },
    toggle(index) {
      this.activeIndex = index;
      this.getList();
    },
    lookMore() {
      this.$router.push(`/information/${this.activeIndex}`);
    },
    handleToNewsDetails(item) {
      let windowUrl = this.$router.resolve({
        path: '/pdfLook',
        query: { fileUrl: item.content_file }
      })
      window.open(windowUrl.href, '_blank')
    },
  },
};
</script>

<style lang="scss" scoped>
.h2 {
  // @media screen and (max-width: 768px) {
  //   margin-top: 40px;
  // }
}

// 移动端标签页样式
.tab {
  &.mobile-layout {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 20px;
    
    .tab-item {
      flex: 1;
      min-width: 120px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: #f5f5f5;
      color: #666;
      border-radius: 22px;
      font-size: 14px;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &.active {
        background: #fbce00;
        color: #663301;
      }
      
      &:hover {
        background: #fbce00;
        color: #663301;
      }
    }
  }
}
.list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  min-width: 1200px; // 设置合理的固定宽度，防止过度缩小
  height: auto;
  padding: 40px 0 70px;
  padding-bottom: 0px;
  gap: 30px;
  
  // 处理浏览器放大后的情况
  @media screen and (min-width: 1201px) {
    min-width: auto; // 1200px以上恢复完全响应式
  }
  
  // @media screen and (max-width: 768px) {
  //   gap: 10px;
  //   padding: 20px 0;
  //   min-width: auto; // 手机端不限制最小宽度
  // }
      
  // 移动端列表布局样式
  &-item {
    display: block;
    width: calc((100% - 30px * 3) / 4);
    // height: auto;
    border-bottom: 0;
    .picture-box {
      @media screen and (max-width: 1600px) and (min-width: 1200px) {
  // 处理浏览器放大后的情况
      @media screen and (min-width: 1201px) {
        min-width: auto; // 1200px以上恢复完全响应式
      }      //   height: 376px;
      }
    }
    // @media screen and (max-width: 768px) {
    //   width: calc(50% - 5px);
    // }

    .title {
      font-weight: bold;
      font-size: 1.1rem;
      color: #663301;
      text-align: center;
      // @media screen and (max-width: 768px) {
      //   height: 40px;
      //   font-size: 16px;
      //   line-height: 20px;
      // }
    }
    .mask {
      // @media screen and (max-width: 768px) {
      //   flex-direction: column;
      //   gap: 10px;
      // }
      .btn {
        margin: 0;
        padding: 0;
        // @media screen and (max-width: 768px) {
        //   width: 100px;
        //   font-size: 12px;
        //   padding: 5px 10px;
        // }
      }
    }
  }
}
.morebtn {
  width: 192px;
  height: 45px;
  // @media screen and (max-width: 768px) {
  //   width: 45%;
  //   height: 2rem;
  // }
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 0;
  background: #fbce00;
  border-radius: 40px;
  border-color: #fbce00;
  font-size: 18px;
  color: #663301;
  &.is-disabled {
    background: #bdbdbd;
    border-color: #bdbdbd;
    color: #fff;
  }
  // @media screen and (max-width: 768px) {
  //   font-size: 14px;
  // }
}

// 移动端按钮样式
.btn-more {
  &.mobile-layout {
    text-align: center;
    margin-top: 20px;
    
    .morebtn {
      width: 100%;
      max-width: 200px;
      height: 44px;
      font-size: 16px;
      
      &:hover {
        background: #d60c18;
        border-color: #d60c18;
        color: #fff;
      }
    }
  }
}
</style>
